import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import menBodymapAnterior from '../../images/bodymap/men-bodymap-anterior.webp';
import menBodymapPosterior from '../../images/bodymap/men-bodymap-posterior.webp';
import menBodymapFace from '../../images/bodymap/men-bodymap-face.webp';
import menBodymapFace2 from '../../images/bodymap/men-bodymap-face-2.webp';
import menBodymapTshirt from '../../images/bodymap/men-bodymap-tshirt.webp';

export function BodymapMenCarousel() {
    return (
        <Carousel>
            <Carousel.Item>
                <img className="d-block w-100" src={menBodymapAnterior} alt="Men Bodymap Anterior" />
            </Carousel.Item>
            <Carousel.Item>
                <img className="d-block w-100" src={menBodymapPosterior} alt="Men Bodymap Posterior" />
            </Carousel.Item>
            <Carousel.Item>
                <img className="d-block w-100" src={menBodymapFace} alt="Men Bodymap Face" />
            </Carousel.Item>
            <Carousel.Item>
                <img className="d-block w-100" src={menBodymapFace2} alt="Men Bodymap Face 2" />
            </Carousel.Item>
            <Carousel.Item>
                <img className="d-block w-100" src={menBodymapTshirt} alt="Men Bodymap T-Shirt Packages" />
            </Carousel.Item>
        </Carousel>
    );
}

export default BodymapMenCarousel;
